



























































import {Component, Vue} from "vue-property-decorator";
import PortalMoneyInput from "@/components/common/PortalMoneyInput.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import PortalTextarea from "@/components/common/PortalTextarea.vue";
import SelectOption from "@/components/common/SelectOption";
import WalletService from "@/services/WalletService";
import {TransferPayload} from "@/dto/wallet/WalletDTOs";
import Application from "@/state/Application";
import {processError} from "@/utils/ComponentUtils";
import moment from "moment";

@Component({
  components: {
    PortalMoneyInput,
    PortalSelect,
    PortalDate,
    PortalTextarea,
  }
})
export default class WalletTransferModal extends Vue {
  private companyId: number | null = null;
  private fromAccountId: number | null = null;
  private toAccountId: number | null = null;
  private amountCents: number | null = null;
  private date = "";
  private description = "";
  private sublimeAccountOptions: Array<SelectOption> = [];
  private sameAccountError = false;

  beforeOpen(event: any) {
    this.companyId = event.params.companyId;
    this.sublimeAccountOptions = event.params.sublimeAccountOptions || [];
    this.fromAccountId = null;
    this.toAccountId = null;
    this.amountCents = null;
    this.date = moment().format("YYYY-MM-DD");
    this.description = "";
    this.sameAccountError = false;
    this.$validator.reset();
  }

  closeModal() {
    this.$modal.hide("wallet-transfer-modal");
  }

  async submit() {
    this.sameAccountError = Number(this.fromAccountId) === Number(this.toAccountId) && this.fromAccountId != null;
    const valid = await this.$validator.validateAll();
    if (!valid || this.sameAccountError || !this.companyId || !this.fromAccountId || !this.toAccountId || !this.amountCents || this.amountCents <= 0) {
      return;
    }
    const payload = new TransferPayload({
      fromAccountId: Number(this.fromAccountId),
      toAccountId: Number(this.toAccountId),
      amountCents: this.amountCents,
      date: this.date,
      description: this.description || null,
    });
    Application.startLoading();
    WalletService.transfer(this.companyId, payload).then(
        () => {
          Application.stopLoading();
          this.$emit("saved");
          this.closeModal();
        },
        err => processError(err, this),
    );
  }
}
